import gsap from 'gsap'
import { CustomEase } from "gsap/CustomEase";

class Loading {
  constructor(el) {
    this.dom = {el: el};
    this.dom.mark = this.dom.el.querySelector('[data-js="mark"]');

    this.hash = location.hash;

    this.init();
  }

  init() {

    window.addEventListener('load', () => {
        setTimeout(()=>{
          if (!this.hash) {
            window.scroll({top: 0, behavior: 'instant'});
          } else {
            window.scroll({top: this.getPositionScroll(this.hash.substr(1)), behavior: 'instant'});
          }
        }, 100)
      this.start();
    })
  }

  start() {
    document.body.dataset.scroll = 'disable';
    gsap.to(this.dom.mark, {
      scale: 1,
      opacity: 1,
      duration: 1.2,
      delay: .6,
      ease: CustomEase.create("custom", "M0,0 C0.814,0.343 0.492,1 1,1 "),
      onComplete: ()=>{

        gsap.to(this.dom.el, {
          opacity: 0,
          duration: .9,
          delay: .3,
          onComplete: () => {
            document.body.dataset.opening = 'end';
            document.body.removeAttribute('data-scroll');
            this.dom.el.remove();
          }
        });

      }
    })
  }

  getPositionScroll(id) {
    const element = document.getElementById(id);
    const targetDOMRect = element.getBoundingClientRect();
    return targetDOMRect.top + window.pageYOffset;
  }
}

export default Loading
